export default (function () {
  const ua = window.navigator.userAgent
  return ua.toLowerCase().indexOf('zhuanzhuan') > 0
})()
